module.exports = __webpack_public_path__ + "img/curacao.cdd11806.svg";